<template>
    <div class="text-center">
        <v-img src="@/assets/img/403.svg" :aspect-ratio="1.97" width="636" class="mb-10"></v-img>
        <h2 class="text-primary font-weight-bold">دسترسی شما به سامانه محدود شده است</h2>
        <p class="text-meta mb-5 mt-2 font-medium text-primary">در صورت نیاز با مدیر سامانه در این خصوص در ارتباط باشید.</p>
        <v-btn color="primary" @click="router.push({path: '/'})">بازگشت به سامانه</v-btn>
    </div>
</template>
<script setup>
defineOptions({
    auth: false,
    layout: 'error'
})
const router = useRouter();
</script>
